import { APIGetStores, APIAddStoreMap, APIUpdateStoreMap, APISendStoreMessage, APIUpdateStore, APIGetVendorStore } from '@/apis/APIshop.js'
import { json2query } from '@/utils'

// 跳转到门店
export const goStore = (context, storeID) => {
  let routeData = context.$router.resolve({
    name: 'JxStoreManager',
    query: { storeID }
  })
  window.open(routeData.href, '_blank')
}

// 查询门店
export const getStores = async (json, noLoading) => {
  try {
    let res = await APIGetStores(json2query(json), noLoading)
    return res
  } catch (e) {
    throw e
  }
}

export const proxyGetStores = (function () {
  const cacheObj = {}
  return function () {
    let args = Array.prototype.join.call(arguments, ',')
    if (args in cacheObj) {
      return cacheObj[args]
    }
    cacheObj[args] = getStores(...arguments)
    return cacheObj[args]
  }
})()

// 通过关键字查询所有门店
export const getAllStoresByKeyword = async (marketManPhone, noLoading) => {
  try {
    let res = await getStores({
      marketManPhone,
      offset: 0,
      pageSize: -1
    }, noLoading)
    return res
  } catch (e) {
    throw e
  }
}

// 查询单个门店信息
export const getOneStore = async (storeID, noLoading = true) => {
  try {
    let res = await getStores({
      storeIDs: JSON.stringify([storeID]),
      offset: 0,
      pageSize: -1
    }, noLoading)
    return res
  } catch (e) {
    throw e
  }
}

/**
 * 添加平台门店绑定
 * @param {*} storeID
 * @param {*} vendorID
 * @param {*} vendorOrgCode 选填
 * @param {*} payload {"vendorStoreID":"103083","autoPickup":1,"deliveryCompetition":1,"pricePercentage":100,"isSync":1,"pricePercentagePack":"美团调价策略7.18"}
 */
export const addStoreMap = async (json, noLoading = false) => {
  try {
    await APIAddStoreMap(json2query(json), noLoading)
  } catch (e) {
    throw e
  }
}

/**
 * 修改平台门店绑定
 * @param {*} storeID
 * @param {*} vendorID
 * @param {*} payload {"vendorStoreID":"103083","autoPickup":1,"deliveryCompetition":1,"pricePercentage":100,"isSync":1,"pricePercentagePack":"美团调价策略7.18"}
 */
export const updateStoreMap = async (json, noLoading = false) => {
  try {
    await APIUpdateStoreMap(json2query(json), noLoading)
  } catch (e) {
    throw e
  }
}

/**
 * 修改门店
 * @param {*} storeID
 * @param {*} payload
 */
export const updateStore = async (json, noLoading = false) => {
  try {
    await APIUpdateStore(json2query(json), noLoading)
  } catch (e) {
    throw e
  }
}

/* 发送消息
  storeIDs
  title
  content
  isAsync
  isContinueWhenError
*/
export const sendMsg = async (json, noLoading = false) => {
  try {
    let res = await APISendStoreMessage(json2query(json), noLoading)
    return res
  } catch (e) {
    throw e
  }
}

// 更新门店信息

/* 查询远端门店
vendorStoreID
vendorID
vendorOrgCode
*/
export const getVendorStore = async (json) => {
  try {
    const res = await APIGetVendorStore(json)
    return res
  } catch (e) {
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/apis/controls/shop.js